module.exports = __webpack_public_path__ + "img/home_title2.083093c6.png";